import React from "react";
import TableLogComponents from "../../components/TableLogComponents";
import Pagination from "../../components/Pagination";
import { useHistory } from "react-router-dom";
import { BiDotsVerticalRounded } from "react-icons/bi";

export default function TableStudents() {
  var history = useHistory();
  const rowTableLogRealtime = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "Firstname",
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: "Lastname",
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
    },
    {
      title: "Room",
      dataIndex: "room",
      key: "room",
    },
    {
      title: "Advisor",
      dataIndex: "advisor",
      key: "advisor",
    },{
      render: (data) => (
        <div className="cursor-pointer" onClick={() => history.push("/students/personal")}>
         <BiDotsVerticalRounded size={25} />
        </div>
      ),
    }
  ];

  const columnsTableLogRealtime = [
    {
      no: "1",
      firstname: "firstname 1",
      lastname: "lastname 1",
      id: "ID 1",
      class: "M5",
      room: "1",
      advisor: "T.Pattarapon",
    },
    {
      no: "2",
      firstname: "firstname 2",
      lastname: "lastname 2",
      id: "ID 2",
      class: "M5",
      room: "2",
      advisor: "T.Pattarapon",
    },
    {
      no: "3",
      firstname: "firstname 3",
      lastname: "lastname 3",
      id: "ID 3",
      class: "M5",
      room: "3",
      advisor: "T.Pattarapon",
    },
  ];

  return (
    <div
      className="box-table-by-nile"
      // onClick={() => {
      //   history.push("/students/personal");
      // }}
    >
      <TableLogComponents
        columns={rowTableLogRealtime}
        dataSource={columnsTableLogRealtime}
      />
      <br />
      <div style={{ float: "right" }}>
        <Pagination />
      </div>
    </div>
  );
}
